import _ from 'lodash';
import { NIL, parse as parseUUID } from 'uuid';
import { getRoomNameScorer } from './roomNameScorer';
// The null UUID.
const NIL_UUID = parseUUID(NIL);
const _zxcvbnCache = new Map();
/**
 * Checks if the given string is a valid UUID or not.
 *
 * @param {string} str - The string to be checked.
 * @returns {boolean} - Whether the string is a valid UUID or not.
 */
function isValidUUID(str) {
    let uuid;
    try {
        uuid = parseUUID(str);
    }
    catch (e) {
        return false;
    }
    return !_.isEqual(uuid, NIL_UUID);
}
/**
 * Checks a room name and caches the result.
 *
 * @param {RoomNameScorer} scorer - The zxcvbn scorer.
 * @param {string} roomName - The room name.
 * @returns {Object}
 */
function _checkRoomName(scorer, roomName = '') {
    if (_zxcvbnCache.has(roomName)) {
        return _zxcvbnCache.get(roomName);
    }
    const result = scorer(roomName);
    _zxcvbnCache.set(roomName, result);
    return result;
}
/**
 * Returns true if the room name is considered a weak (insecure) one.
 *
 * Callers check `isUnsafeRoomWarningEnabled()` first: on web the scorer is
 * downloaded on the first call, and reports false until it has loaded.
 *
 * @param {string} roomName - The room name.
 * @returns {boolean}
 */
export default function isInsecureRoomName(roomName = '') {
    // room names longer than 200 chars we consider secure
    if (isValidUUID(roomName) || roomName.length >= 200) {
        return false;
    }
    const scorer = getRoomNameScorer();
    if (!scorer) {
        return false;
    }
    return _checkRoomName(scorer, roomName).score < 3;
}
